module.exports = __webpack_public_path__ + "img/wuliu_banner_san.2970f6f8.jpg";